<template>
  <JModal v-model="internalModelValue" size="xs" persistent>
    <div class="flex gap-10 align-middle">
      <div>
        <span
          class="flex h-32 w-32 items-center justify-center rounded-full border border-gray-300 bg-gray-200"
        >
          <JIcon size="16" name="tick-circle" class="text-gray-500" />
        </span>
      </div>
      <div class="text-pane-header">
        {{ $t('support.sentToEmailMessageTitle') }}
      </div>
    </div>
    <div class="pb-20">
      <h5 class="mb-10 mt-5 break-words font-thin text-gray-500">
        {{ $t('support.sentToEmailMessage') }}
      </h5>

      <div class="w-full">
        <JButton
          block
          color="primary"
          class="rounded-sm"
          @click="internalModelValue = false"
        >
          {{ $t('words.ok') }}
        </JButton>
      </div>
    </div>
  </JModal>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import { JButton, JIcon, JModal } from '@journey/ui-kit'
import type { Emits, Props } from './ContactSupportConfirmationDialog.types'

// TOGGLE
const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
})

const emit = defineEmits<Emits>()

const internalModelValue = useVModel(props, 'modelValue', emit)
</script>
